// Shopify Predictive Search - https://shopify.dev/docs/themes/navigation-search/search/predictive-search
// Note: this file is copied to `assets/predictive-search.js` (not webpack-bundled), so it
// must stay classic-script compatible — no `import` / `export`.
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.form = this.querySelector('form');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.searchOverlay = document.querySelector('#search-overlay');
        this.resourcesType = this.input.dataset.resourcesType;
        this.mobileDisable = this.input.dataset.mobileDisable;

        if (this.mobileDisable === 'false') {
            this.input.addEventListener(
                'input',
                this.debounce((event) => {
                    this.onChange(event);
                }, 300).bind(this)
            );
        }

        // Redirect on Enter
        this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                this.redirectToProductsTab();
            }
        });

        // Redirect on form submit (e.g., submit button click)
        this.form?.addEventListener('submit', (e) => {
            e.preventDefault();
            this.redirectToProductsTab();
        });
    }

    redirectToProductsTab() {
        const searchTerm = this.input.value.trim();
        if (searchTerm) {
            const encodedTerm = encodeURIComponent(searchTerm);
            window.location.href = `/search?q=${encodedTerm}&type=product`;
        }
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm, this.resourcesType);
    }

    getSearchResults(searchTerm, resourcesType) {
        fetch(
            `/search/suggest?q=${searchTerm}&resources[type]=${resourcesType}&resources[limit]=10&section_id=predictive-search`
        )
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }

            return response.text();
        })
        .then((text) => {
            const resultsMarkup = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('#shopify-section-predictive-search').innerHTML;

            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.open();
        })
        .catch((error) => {
            this.close();
            throw error;
        });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
        this.searchOverlay.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.searchOverlay.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

if (!customElements.get('iam-predictive-search')) {
    customElements.define('iam-predictive-search', PredictiveSearch);
}
